<div [class.hidden]="!show">
  <ng-content *ngIf="show"></ng-content>
</div>
